import freeMap from "./free.json";
import essentialsMap from "./essentials.json";
import proMap from "./pro.json";

export const planMap = {
    Free: freeMap,
    Essentials: essentialsMap,
    Pro: proMap,
};
